import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { IMAGES } from "@/assets/images";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface MenuModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MenuModal({ isOpen, onClose }: MenuModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl max-h-[90vh] overflow-y-auto bg-white">
        <DialogHeader>
          <DialogTitle className="text-3xl font-bold text-primary flex items-center justify-between">
            <span>Our Menu</span>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              className="h-10 w-10 hover:bg-muted"
            >
              <X className="h-6 w-6" />
            </Button>
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-6 mt-6">
          <div className="rounded-lg overflow-hidden border border-border shadow-lg w-full">
            <img
              src={IMAGES.IMG_5F7B1E3D562114F1102BEB1C90C0BDAA_50}
              alt="Liuyishou Hot Pot Menu - Page 1"
              className="w-full h-auto"
            />
          </div>
          <div className="rounded-lg overflow-hidden border border-border shadow-lg w-full">
            <img
              src={IMAGES.A62CA056B206A947B3E492E49286DDFA_48}
              alt="Liuyishou Hot Pot Menu - Page 2"
              className="w-full h-auto"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
